export default __webpack_public_path__ + "static/logo-primary-8bf28cff0f468c5a99fdba1890fe3536.png";